export const IShareScreenViewModelType = Symbol('IShareScreenViewModel');
